export const COMMAND_NAME_VALID_REGEXP = /^[\p{L}\p{N} +-/]*$/u;
export const COMMAND_NAME_VALID_REGEXP_NOT_DOT = /^[^.]*$/u;
export const RBE_AUTOMATION_NAME_VALID_REGEXP = /^[\p{L}\p{N} [\]+-/]*$/u;
export const NEW_COMMAND_NAME_VALID_REGEXP = /^[a-zA-Z0-9à-ö \p{L}\p{N}]*$/u;

export enum ECommands {
    calibrate = 1,
    open = 2,
    opentotal = 3,
    openpartial = 4,
    close = 5,
    openforced = 6,
    openauto = 7,
    openclose = 8,
    sequential = 9,
    align = 10,
    free = 11,
    resume = 12,
    openpedestrian = 64,
}
